<script lang="ts">
	import { goto, onNavigate } from '$app/navigation';
	import { onMount } from 'svelte';

	let searchQuery = '';

	let searchResultsCount = 0;
	export let resultsList:
		| Array<{ _id: string; name: string; category: string }>
		| undefined = undefined;
	let searchResultsElement: HTMLDataListElement | undefined;
	let isMobile = false;

	onMount(() => {
		if (typeof window !== 'undefined') {
			isMobile = window.matchMedia('(max-width: 768px)').matches;
		}
	});

	$: {
		if (searchResultsElement !== undefined) {
			if (searchResultsElement?.options.length > 0) {
				searchResultsCount = 0;
				for (let option of searchResultsElement?.options) {
					if (
						option.value
							.toLowerCase()
							.includes(searchQuery.toLowerCase().trim())
					) {
						searchResultsCount += 1;
					}
				}
			}
		}
	}

	function navigateToSelectedProduct() {
		if (searchResultsElement !== undefined) {
			for (let option of searchResultsElement?.options) {
				if (option.value.toLowerCase() === searchQuery.toLowerCase().trim()) {
					let [productName, productCategory] = option.value.split(': ');
					let selectedProduct = resultsList?.find(
						(product) =>
							product.name === productName &&
							product.category === productCategory
					);
					if (selectedProduct !== undefined) {
						let newPath = `/products/${selectedProduct._id}`;
						if (window.location.pathname !== newPath) {
							window.location.href = newPath;
						}
					}
				}
			}
		}
	}

	onNavigate(() => {
		searchQuery = '';
		searchResultsCount = 0;
	});
</script>

{#if resultsList == undefined}
	<p>
		Something went wrong when trying to load our products. Please try again.
	</p>
{:else}
	<div class="relative">
		<input
			style="-webkit-appearance: none; -moz-appearance: none; appearance: none;"
			class="w-full rounded-md border-gray-200 py-2.5 pe-10 shadow-sm focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
			type="search"
			bind:value={searchQuery}
			list="searchResults"
			placeholder="Search our treats..."
			aria-label="Search our treats"
			on:input={() => navigateToSelectedProduct()}
		/>
		<span
			class="absolute inset-y-0 end-0 grid w-10 place-content-center"
			aria-hidden="true"
		>
			<button
				><span
					class="fa-duotone fa-magnifying-glass text-logoBackgroundBlue"
				/></button
			>
		</span>

		<datalist id="searchResults" bind:this={searchResultsElement}>
			{#each resultsList as result}
				<option value={result.name + ': ' + result.category} />
			{/each}
		</datalist>
	</div>
{/if}
